import parse from 'date-fns/parse'
import format from 'date-fns/format'
import nlLocale from 'date-fns/locale/nl'

/**
 * @param {string | null | undefined} dateTime
 * @returns {string | undefined}
 */
export const dateTimeToDate = (dateTime) => {
  if (!dateTime) {
    return undefined
  }
  if (typeof dateTime === 'object') {
    dateTime = dateTime.toISOString()
  }
  try {
    // Handle full ISO with time (e.g. 2025-11-12T10:00:00.000Z)
    if (dateTime.includes('T')) {
      const formatString = 'yyyy-MM-ddHH:mm:ss.SSSX'
      const parsed = parse(dateTime.replace('T', ''), formatString, new Date())
      return format(parsed, 'dd-MM-yyyy', { locale: nlLocale })
    }
    // Handle date-only strings (e.g. 2025-11-12)
    const parsedSimple = new Date(dateTime)
    if (!isNaN(parsedSimple.getTime())) {
      return format(parsedSimple, 'dd-MM-yyyy', { locale: nlLocale })
    }
  } catch (e) {
    // fall through to undefined return
  }
  return undefined
}

export const dateTimeToVerboseString = (dateTime, formatString = 'PPPp') => {
  if (typeof dateTime === 'string') {
    dateTime = new Date(dateTime)
  }
  return format(dateTime, formatString, {
    locale: nlLocale
  })
}
